import { Component, forwardRef } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../../utils/Loader";

import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess } from "../../../../utils/constants";
import Pagination from "../../../../utils/pagination";
import { sendEmailOfAvailableArea_action, moveToApplyStatus_action, sendWaitingEmail_action, getApplicationStatusManagementList_action } from '../../../../actions/admin_module_action/manage_area/application_status_management_action/application_status_management_action';
import { fill_action } from '../../../../actions/fillCombo_action';
import { allExhibitorNameActionIdId, accountTypeActionId, statusTypeActionId, primaryChapterActionId, exhibitionId } from "../../../../utils/constants";
import moment from 'moment';
class ApplicationStatusManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentPage: 1,
            applicationStatusManagementList: [],
            isDisable: true,
            allSelected: false,
            exhibitorList: [],
            bookingStatusId: '',
            bookingStatusList: '',
            exhibitionId: '',
            exhibitionList: [],
            ChapterName: '',
            BookingStatusId: '',
            primaryChapterList: [],
            exhibitorId: '',
            sumOfArea: '',
        }

        this.updateItem = this.updateItem.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.getFillList(allExhibitorNameActionIdId, '', '', '', '', '');
        this.getFillList(accountTypeActionId, '', '', '', '', '');
        this.getFillList(primaryChapterActionId, '', '', '', '', '');
        this.getFillList(statusTypeActionId, '', '', '', '', '');
        this.getFillList(exhibitionId, '', '', '', '', '');

        this.getApplicationStatusManagementList()

    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
            .then((data) => {
                if (data.error != 1) {
                    // voucher list
                    if (actionID === allExhibitorNameActionIdId) {
                        // console.log("exhibitorList", data.data)
                        this.setState({
                            exhibitorList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === statusTypeActionId) {
                        // console.log("accountTypeList", data.data)
                        this.setState({
                            bookingStatusList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === primaryChapterActionId) {
                        // console.log("voucher type data", data.data)
                        this.setState({
                            primaryChapterList: data.data, isLoading: false,
                        })
                    }
                    if (actionID === exhibitionId) {
                        // console.log("voucher type data", data.data)
                        this.setState({
                            exhibitionList: data.data, isLoading: false,
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getApplicationStatusManagementList() {
        const { bookingStatusId, exhibitionId, exhibitorId, ChapterName } = this.state
        this.setState({ isLoading: true })
        this.props.getApplicationStatusManagementList_action(exhibitionId, exhibitorId, ChapterName, bookingStatusId)
            .then((data) => {
                if (data.error != 1) {
                    data.data != '' && data.data != null ?

                        data.data.map((item) => {
                            item.Is_checked = 0
                        })

                        : <></>
                    console.log("data", data)
                    this.setState({ isLoading: false, applicationStatusManagementList: data.data })

                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    sumOfArea() {
        const { applicationStatusManagementList } = this.state

        const newArray = []

        applicationStatusManagementList.map((data) => {
            if (data.Is_checked == 1) {
                newArray.push(data)
            }
        })

        const sum = newArray.reduce((acc, obj) => acc + obj.AREA, 0);

        this.setState({ sumOfArea: sum })
    }

    checkedBoxList(pList, index, e) {
        const { applicationStatusManagementList } = this.state
        const event = e.target.checked

        if (event == true) {
            pList.forEach((data, i) => {
                if (i === index) {
                    data.Is_checked = 1
                }
            });

        } else {
            pList.forEach((data, i) => {
                if (i === index) {
                    data.Is_checked = 0
                }
            });
        }
        setTimeout(() => {
            this.sumOfArea()
        }, 100);
        console.log("pList", pList)

        const checkboxDisable = applicationStatusManagementList.some(item => item.Is_checked == 1)

        // debugger
        if (checkboxDisable) {
            this.setState({ isDisable: false })
        }
        else {
            this.setState({ isDisable: true })
        }

        const allSelectedChecked = applicationStatusManagementList.every(item => item.Is_checked == 1)

        // debugger
        if (allSelectedChecked) {
            this.setState({ allSelected: true })
        }
        else {
            this.setState({ allSelected: false })
        }

    }

    allSelectedCheckbox(e) {
        const { applicationStatusManagementList } = this.state

        if (e.target.checked == true) {
            applicationStatusManagementList.map((data) => {
                data.Is_checked = 1
            })
            this.setState({ allSelected: true, isDisable: false })
        } else {
            applicationStatusManagementList.map((data) => {
                data.Is_checked = 0
            })
            this.setState({ allSelected: false, isDisable: true })
        }

        setTimeout(() => {
            this.sumOfArea()
        }, 100);
    }

    handleClear() {
        const { applicationStatusManagementList } = this.state

        this.setState({
            exhibitorId: '',
            currencyID: '',
            fromAmount: '',
            toAmount: '',
            accountTypeId: '',
            currencyId: '',
            isDisable: true,
            allSelected: false,
            exhibitionId: '',
            bookingStatusId: '',
            ChapterName: ''
        })
        setTimeout(() => {
            this.getApplicationStatusManagementList()
            this.sumOfArea()
        }, 100);
        applicationStatusManagementList != '' ?
            applicationStatusManagementList.map((data) => {
                data.Is_checked = 0
            }) : <></>
    }

    sendEmailOfAvailableArea() {
        const { applicationStatusManagementList } = this.state
        const list = []
        applicationStatusManagementList.map((data) => {
            if (data.Is_checked == 1) {
                list.push(
                    {
                        ReceiptID: data.ReceiptID
                    }
                )
            }
        })
        console.log("applicationStatusManagementList", list)
        this.setState({ isLoading: true })
        this.props.sendEmailOfAvailableArea_action(list)
            .then((data) => {
                if (data.error != 1) {
                    console.log("data", data)
                    this.setState({ isLoading: false })
                    toastSuccess("Email Send successfully!")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    moveToApplyStatus() {
        const { applicationStatusManagementList } = this.state
        const list = []
        applicationStatusManagementList.map((data) => {
            if (data.Is_checked == 1) {
                list.push(
                    {
                        ReceiptID: data.ReceiptID
                    }
                )
            }
        })
        console.log("applicationStatusManagementList", list)
        this.setState({ isLoading: true })
        this.props.moveToApplyStatus_action(list)
            .then((data) => {
                if (data.error != 1) {
                    console.log("data", data)
                    this.setState({ isLoading: false })
                    toastSuccess("Email Send successfully!")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    sendWaitingEmail() {
        const { applicationStatusManagementList } = this.state
        const list = []
        applicationStatusManagementList.map((data) => {
            if (data.Is_checked == 1) {
                list.push(
                    {
                        UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                        ExhibitionID: data.ExhibitionID,
                        ExhRegistrationID: data.ExhRegistrationID
                    }
                )
            }
        })
        console.log("applicationStatusManagementList", list)
        this.setState({ isLoading: true })
        this.props.sendWaitingEmail_action(list)
            .then((data) => {
                if (data.error != 1) {
                    console.log("data", data)
                    this.setState({ isLoading: false })
                    toastSuccess("Email Send successfully!")
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    updateItem(item) {
        const { applicationStatusManagementList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = applicationStatusManagementList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(applicationStatusManagementList.length / recordsPerPage)
    }

    render() {
        const { isLoading, applicationStatusManagementList, exhibitorId, exhibitorList, currentPage, isDisable, allSelected, ChapterName, primaryChapterList, bookingStatusList, bookingStatusId, exhibitionId, exhibitionList, sumOfArea } = this.state

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = applicationStatusManagementList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(applicationStatusManagementList.length / recordsPerPage)

        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />

                    <div class="mx-4 me-3">

                        <div className="row exb-topp align-items-end g-2">

                            {/* Exhibition */}
                            <div className="col-12 col-md-3">
                                <label>Exhibition</label>
                                <select
                                    className="form-control"
                                    value={exhibitionId}
                                    onChange={(e) => this.setState({ exhibitionId: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {exhibitionList.length > 0 &&
                                        exhibitionList.map((data) => (
                                            <option key={data.ExhibitionID} value={data.ExhibitionID}>
                                                {data.ExhibitionName}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {/* Exhibitor */}
                            <div className="col-12 col-md-2">
                                <label>Exhibitor</label>
                                <select
                                    className="form-control"
                                    value={exhibitorId}
                                    onChange={(e) => this.setState({ exhibitorId: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {exhibitorList.length > 0 &&
                                        exhibitorList.map((data) => (
                                            <option key={data.ExhRegistrationID} value={data.ExhRegistrationID}>
                                                {data.CompanyName}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {/* Chapter */}
                            <div className="col-12 col-md-3">
                                <label>Chapter</label>
                                <select
                                    className="form-control"
                                    value={ChapterName}
                                    onChange={(e) => this.setState({ ChapterName: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {primaryChapterList.length > 0 &&
                                        primaryChapterList.map((data) => (
                                            <option key={data.PrimaryChapter} value={data.PrimaryChapter}>
                                                {data.PrimaryChapter}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {/* Status */}
                            <div className="col-12 col-md-2">
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={bookingStatusId}
                                    onChange={(e) => this.setState({ bookingStatusId: e.target.value })}
                                >
                                    <option value="">Select</option>
                                    {bookingStatusList.length > 0 &&
                                        bookingStatusList.map((data) => (
                                            <option key={data.ID} value={data.ID}>
                                                {data.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>

                            {/* Buttons */}
                            <div className="col-12 col-md-2 d-flex align-items-end justify-content-end gap-2">
                                <button
                                    className="btn btn-aqua"
                                    onClick={() => this.getApplicationStatusManagementList()}
                                >
                                    Search
                                </button>

                                <button
                                    className="btn btn-gray"
                                    onClick={() => this.handleClear()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>

                            <div className="col-12 d-flex flex-wrap align-items-center justify-content-end gap-2 mt-3 p-0">

                                {/* Action Buttons */}
                                <button
                                    className="btn btn-aqua"
                                    disabled={isDisable}
                                    onClick={() => this.sendEmailOfAvailableArea()}
                                >
                                    Send Email of Available Area
                                </button>

                                <button
                                    className="btn btn-aqua"
                                    disabled={isDisable}
                                    onClick={() => this.moveToApplyStatus()}
                                >
                                    Move to Apply Status
                                </button>

                                <button
                                    className="btn btn-aqua"
                                    disabled={isDisable}
                                    onClick={() => this.sendWaitingEmail()}
                                >
                                    Send Waiting Email
                                </button>

                                {/* Info Badges */}
                                <span className="btn btn-aqua">
                                        Balance Area : 0 m<sup>2</sup>
                                </span>

                                <span className="btn btn-aqua">
                                        Selected Exhibitor Area : {sumOfArea ? sumOfArea : 0} m<sup>2</sup>
                                </span>

                            </div>

                        <div class="table-responsive mb-5 mt-2 p-0">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                <thead>
                                    <tr>
                                        <th class="text-center" style={{width:'60px'}}>
                                            <input type="checkbox"
                                                onClick={(e) => this.allSelectedCheckbox(e)}
                                                checked={allSelected}
                                            /></th>
                                        <th>Exhibuter Name</th>
                                        <th>Reference No.</th>
                                        <th style={{ width: '15%' }}> Registration Date</th>
                                        <th>Chapter</th>
                                        <th>Area</th>
                                        <th>Status</th>
                                        <th>Currency</th>
                                        <th>Payment Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentRecords.length > 0 && currentRecords != null ?
                                            currentRecords.map((data, i) => (
                                                <tr>
                                                    <td class="text-center"> <input type="checkbox"
                                                        onClick={(e) => this.checkedBoxList(currentRecords, i, e)}
                                                        checked={data.Is_checked}
                                                        class="" name=""
                                                    /> </td>
                                                    <td>{data.CompanyName != null ? data.CompanyName : '-'}</td>
                                                    <td>{data.REFNO != null ? data.REFNO : '-'}</td>
                                                    <td>{data.BOOKING_DATE != null ? moment(data.BOOKING_DATE).format('DD-MM-YYYY') : '-'}</td>
                                                    <td>{data.ChapterName != null ? data.ChapterName : '-'}</td>
                                                    <td>{data.AREA != null ? data.AREA : '-'}</td>
                                                    <td>{data.Status != null ? data.Status : '-'}</td>
                                                    <td>{data.Code != null ? data.Code : '-'}</td>
                                                    <td>{data.PaymentType != null ? data.PaymentType : '-'}</td>

                                                </tr>
                                            )) : (<tr><td colSpan={10} className='text-center'>Record not found</td></tr>)
                                    }

                                </tbody>
                            </table>
                            <div className="mt-2 float-left">
                                {
                                    applicationStatusManagementList.length > 0 ?
                                        <Pagination
                                            nPages={nPages}
                                            currentPage={currentPage}
                                            setCurrentPage={this.updateItem}
                                        /> : <></>
                                }
                                <div className="tab-rec " style={{ float: "right" }}>
                                    <p>{`${currentPage} of ${nPages} pages`}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </>

                {/* <Footerwithdr /> */}

            </>
        );
    }


}

export default withRouter(connect(null, { getApplicationStatusManagementList_action, sendEmailOfAvailableArea_action, moveToApplyStatus_action, sendWaitingEmail_action, fill_action })(ApplicationStatusManagement));